import styled from "styled-components";
import css from "@styled-system/css";

import Typography from "../Typography/Typography";

import { PaginationTotalsProps } from "./pagination.type";

const PaginationTotalsLabel = styled(Typography)`
  opacity: 0.7;
  ${css({
    color: "grey-blue",
    textAlign: ["center", "left"],
  })}
`;

const PaginationTotalsNumber = styled.span`
  display: inline-block;
  ${css({
    marginX: 1,
    fontWeight: "bold",
  })}
`;

const PaginationTotals = ({
  totalItemsCount,
  itemsPerPage,
  pageCount = 1,
  currentPage = 1,
}: PaginationTotalsProps) => {
  const rangeStart = (currentPage - 1) * itemsPerPage + 1;
  const rangeEnd =
    currentPage === pageCount ? totalItemsCount : currentPage * itemsPerPage;

  return (
    <PaginationTotalsLabel
      variant="body"
      aria-label={`Showing ${rangeStart}-${rangeEnd} of ${totalItemsCount}`}
    >
      Showing
      <PaginationTotalsNumber>
        {rangeStart}-{rangeEnd}
      </PaginationTotalsNumber>
      of
      <PaginationTotalsNumber>{totalItemsCount}</PaginationTotalsNumber>
    </PaginationTotalsLabel>
  );
};

export default PaginationTotals;
